import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { usePatientAuth } from "@/context/PatientAuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, HeartPulse, ArrowLeft } from "lucide-react";

export default function PortalLogin() {
  const { login } = usePatientAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try { await login(email.trim(), password); navigate("/portal"); }
    catch (err) { setError(formatApiError(err.response?.data?.detail) || "Login failed"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-gradient-to-b from-teal-50 to-slate-50 p-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2.5 justify-center mb-6">
          <span className="h-11 w-11 rounded-xl bg-teal-600 grid place-items-center text-white"><HeartPulse className="h-6 w-6" /></span>
          <div><div className="font-display text-lg font-semibold text-slate-900">SPAN Patient Portal</div><div className="text-xs text-slate-500">Your appointments & reminders</div></div>
        </div>
        <div className="bg-white border border-slate-200 rounded-xl p-8 shadow-sm">
          <h2 className="font-display text-xl font-bold text-slate-900">Sign in</h2>
          <p className="text-sm text-slate-500 mt-1">Access your visits, follow-ups and notifications.</p>
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="portal-login-form">
            <div className="space-y-1.5"><Label>Email or mobile</Label><Input value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="portal-email-input" placeholder="you@email.com" /></div>
            <div className="space-y-1.5"><Label>Password</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="portal-password-input" /></div>
            {error && <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2" data-testid="portal-login-error">{error}</div>}
            <Button type="submit" disabled={loading} className="w-full bg-teal-600 hover:bg-teal-700" data-testid="portal-login-button">{loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign in"}</Button>
          </form>
          <div className="mt-4 text-xs text-slate-400 bg-slate-50 border border-slate-200 rounded-md px-3 py-2">Demo: <span className="font-mono">amit@demo.health</span> / <span className="font-mono">Patient@2026</span></div>
        </div>
        <Link to="/login" className="mt-6 inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-700 justify-center w-full" data-testid="portal-staff-link"><ArrowLeft className="h-4 w-4" /> Staff sign in</Link>
      </div>
    </div>
  );
}
